(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6600],{

/***/ 53831:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us/consultancy",
      function () {
        return __webpack_require__(52098);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 52098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ index_page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/ramda/es/index.js + 227 modules
var es = __webpack_require__(36486);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 12 modules
var esm = __webpack_require__(10686);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/formik-antd/es/input/index.js
var input = __webpack_require__(96127);
// EXTERNAL MODULE: ./node_modules/formik-antd/es/input-number/index.js + 10 modules
var input_number = __webpack_require__(84796);
// EXTERNAL MODULE: ./node_modules/formik-antd/es/select/index.js
var es_select = __webpack_require__(76453);
// EXTERNAL MODULE: ./node_modules/formik-antd/es/form-item/index.js
var form_item = __webpack_require__(29553);
// EXTERNAL MODULE: ./node_modules/formik-antd/es/date-picker/index.js + 55 modules
var date_picker = __webpack_require__(56507);
// EXTERNAL MODULE: ./node_modules/formik-antd/es/checkbox/index.js
var es_checkbox = __webpack_require__(42842);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./packages/datasource/src/api/contactUs/index.js
var contactUs = __webpack_require__(77169);
// EXTERNAL MODULE: ./src/pages/contact-us/commonForm/index.js + 1 modules
var commonForm = __webpack_require__(51844);
// EXTERNAL MODULE: ./src/components/index.js + 20 modules
var components = __webpack_require__(21679);
// EXTERNAL MODULE: ./node_modules/moment/locale/zh-cn.js
var zh_cn = __webpack_require__(83839);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/antd/lib/locale/zh_CN.js
var zh_CN = __webpack_require__(82925);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./src/pages/contact-us/commonForm/commonForm.fields.js
var commonForm_fields = __webpack_require__(14720);
// EXTERNAL MODULE: ./src/pages/contact-us/utils/index.js
var utils = __webpack_require__(84749);
;// CONCATENATED MODULE: ./src/pages/contact-us/consultancy/form/form.fields.js






var getFields = function(param) {
    var lang = param.lang, t = param.t, tidbReleases = param.tidbReleases;
    var dropdownValidator = (0,commonForm_fields/* getDropdownValidator */.Q9)({
        lang: lang
    });
    var textareaValidator = (0,commonForm_fields/* getTextareaValidator */.V5)({
        lang: lang,
        t: t,
        limit: 100
    });
    var inputValidator = yup_es/* mixed */.nK().required(lang.required);
    return {
        tidbNodeNum: {
            name: "tidb_node_num",
            min: 0,
            placeholder: lang.pleaseEnter,
            validator: inputValidator
        },
        tikvNodeNum: {
            name: "tikv_node_num",
            min: 0,
            placeholder: lang.pleaseEnter,
            validator: inputValidator
        },
        tiflashNodeNum: {
            name: "tiflash_node_num",
            min: 0,
            placeholder: lang.pleaseEnter,
            validator: inputValidator
        },
        occupationRateOfTidb: {
            name: "occupation_rate_of_tidb",
            min: 0,
            max: 100,
            placeholder: lang.pleaseEnter,
            validator: inputValidator
        },
        tidbVersion: {
            name: "tidb_version",
            placeholder: lang.pleaseSelect,
            mode: "multiple",
            options: (0,utils/* getTidbReleaseOptions */.O)(tidbReleases),
            validator: dropdownValidator
        },
        keyScene: {
            name: "key_scene",
            placeholder: lang.pleaseEnter,
            validator: (0,commonForm_fields/* getTextareaValidator */.V5)({
                lang: lang,
                t: t,
                limit: 100,
                isRequired: false
            })
        },
        currentArchitecture: {
            name: "current_scenarios_and_architecture",
            placeholder: lang.pleaseEnter,
            validator: textareaValidator
        },
        painPoints: {
            name: "pain_points",
            placeholder: lang.pleaseEnter,
            validator: textareaValidator
        },
        challenge: {
            name: "technical_debt",
            placeholder: lang.pleaseEnter,
            validator: textareaValidator
        },
        expectedBenefits: {
            name: "expect_benefits_from_tidb",
            placeholder: lang.pleaseEnter,
            validator: textareaValidator
        },
        pocDate: {
            name: "launch_or_poc_date",
            locale: zh_CN/* default */.Z,
            disabledDate: function(current) {
                return current && current < moment_default()().endOf("day");
            },
            placeholder: lang.pleaseEnter
        },
        estimate: {
            name: "person_resource",
            min: 0,
            placeholder: lang.pleaseEnter
        },
        tidbUsage: {
            name: "tidb_usage",
            options: [
                {
                    label: "HTAP",
                    value: "htap"
                },
                {
                    label: "OLAP",
                    value: "olap"
                },
                {
                    label: "OLAP Scale",
                    value: "olap_scale"
                },
                {
                    label: "RawKV",
                    value: "rawkv"
                }, 
            ],
            validator: yup_es/* array */.IX().required(lang.required).min(1, lang.required)
        }
    };
};

;// CONCATENATED MODULE: ./src/pages/contact-us/consultancy/form/Form.component.js
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var TextArea = input/* Input.TextArea */.I.TextArea;
var FormComponent = function() {
    var t = (0,esm/* useTranslation */.$G)("page-contact-us", "common").t;
    var data = (0,dist/* default */.ZP)([
        "tidbReleases"
    ]).data;
    var formLocalePath = "consultancy.form";
    var lang = _objectSpread({}, t(formLocalePath, {
        returnObjects: true
    }), t("common:form", {
        returnObjects: true
    }));
    var formFields = getFields({
        lang: lang,
        t: t,
        tidbReleases: data === null || data === void 0 ? void 0 : data.data
    });
    var tidbNodeNum = formFields.tidbNodeNum, tikvNodeNum = formFields.tikvNodeNum, tiflashNodeNum = formFields.tiflashNodeNum, occupationRateOfTidb = formFields.occupationRateOfTidb, tidbVersion = formFields.tidbVersion, keyScene = formFields.keyScene, currentArchitecture = formFields.currentArchitecture, painPoints = formFields.painPoints, challenge = formFields.challenge, expectedBenefits = formFields.expectedBenefits, pocDate = formFields.pocDate, estimate = formFields.estimate, tidbUsage = formFields.tidbUsage;
    var commonFormProps = {
        formFields: formFields,
        formLocalePath: formLocalePath,
        submitApi: contactUs.askForConsultancy,
        submitApiFormatter: function(values) {
            return _objectSpread({}, values, {
                occupation_rate_of_tidb: parseInt(values.occupation_rate_of_tidb, 10) / 100,
                launch_or_poc_date: values.launch_or_poc_date ? dayjs_min_default()(values.launch_or_poc_date).format("YYYY-MM-DD") : undefined
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(commonForm/* default */.Z, _objectSpread({}, commonFormProps, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                xs: 24,
                sm: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RequiredFormItem */.Xz, {
                    label: lang.tidbNodeNum.label,
                    name: tidbNodeNum.name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input_number/* InputNumber */.R, _objectSpread({}, tidbNodeNum))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                xs: 24,
                sm: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RequiredFormItem */.Xz, {
                    label: lang.tikvNodeNum.label,
                    name: tikvNodeNum.name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input_number/* InputNumber */.R, _objectSpread({}, tikvNodeNum))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                xs: 24,
                sm: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RequiredFormItem */.Xz, {
                    label: lang.tiflashNodeNum.label,
                    name: tiflashNodeNum.name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input_number/* InputNumber */.R, _objectSpread({}, tiflashNodeNum))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                xs: 24,
                sm: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RequiredFormItem */.Xz, {
                    label: lang.occupationRateOfTidb.label,
                    name: occupationRateOfTidb.name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input_number/* InputNumber */.R, _objectSpread({}, occupationRateOfTidb))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                xs: 24,
                sm: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RequiredFormItem */.Xz, {
                    label: lang.tidbVersion.label,
                    name: tidbVersion.name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_select/* Select */.P, _objectSpread({}, tidbVersion))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                span: 24,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_item/* FormItem */.x, {
                    label: lang.keyScene.label,
                    name: keyScene.name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea, _objectSpread({}, keyScene))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                span: 24,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RequiredFormItem */.Xz, {
                    label: lang.currentArchitecture.label,
                    name: currentArchitecture.name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea, _objectSpread({}, currentArchitecture))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                span: 24,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RequiredFormItem */.Xz, {
                    label: lang.painPoints.label,
                    name: painPoints.name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea, _objectSpread({}, painPoints))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                span: 24,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RequiredFormItem */.Xz, {
                    label: lang.challenge.label,
                    name: challenge.name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea, _objectSpread({}, challenge))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                span: 24,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RequiredFormItem */.Xz, {
                    label: lang.expectedBenefits.label,
                    name: expectedBenefits.name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextArea, _objectSpread({}, expectedBenefits))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                xs: 24,
                sm: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_item/* FormItem */.x, {
                    label: lang.pocDate.label,
                    name: pocDate.name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(date_picker/* DatePicker */.M, _objectSpread({}, pocDate))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                xs: 24,
                sm: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(form_item/* FormItem */.x, {
                    label: lang.estimate.label,
                    name: estimate.name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(input_number/* InputNumber */.R, _objectSpread({}, estimate))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                span: 24,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* RequiredFormItem */.Xz, {
                    label: lang.tidbUsage.label,
                    name: tidbUsage.name,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(es_checkbox/* Checkbox.Group */.X.Group, _objectSpread({}, tidbUsage))
                })
            })
        ]
    }));
};
/* harmony default export */ var Form_component = (FormComponent);

;// CONCATENATED MODULE: ./src/pages/contact-us/consultancy/form/index.js


// EXTERNAL MODULE: ./src/pages/contact-us/layout/index.js + 3 modules
var layout = __webpack_require__(64174);
;// CONCATENATED MODULE: ./src/pages/contact-us/consultancy/index.page.js
function index_page_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function index_page_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            index_page_defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var Page = function() {
    var t = (0,esm/* useTranslation */.$G)("page-contact-us").t;
    var lang = t("consultancy", {
        returnObjects: true
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* CommunityHead */.Wh, {
                title: lang.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* default */.Z, index_page_objectSpread({}, es/* pick */.eiS([
                "title",
                "subtitle"
            ], lang), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form_component, {})
            }))
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var index_page = (Page);


/***/ }),

/***/ 84749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ getTidbReleaseOptions; }
/* harmony export */ });
/* unused harmony export __N_SSP */
var __N_SSP = true;
var getTidbReleaseOptions = function() {
    var releases = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return releases.map(function(param) {
        var label = param.prefix, children = param.children;
        return {
            label: label,
            options: children.map(function(value) {
                return {
                    value: value,
                    label: value
                };
            })
        };
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8042,7226,4667,8648,9774,2888,179], function() { return __webpack_exec__(53831); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);